import { formatDateValue } from "@/components/lms/lms.utils";

export type LmsEnrolmentLogKey =
  | "invited_on"
  | "started_on"
  | "complete_by"
  | "completed_on"
  | "certificate_last_downloaded_on"
  | "certificate_expires_on";

export interface LmsEnrolmentLogEntry {
  key: LmsEnrolmentLogKey;
  labelKey: string;
  value: string;
}

export interface LmsEnrolmentForLogs {
  created_on?: string | null;
  started_on?: string | null;
  completed_on?: string | null;
  completion_interval_in_days?: number | null;
  due_on?: string | null;
  certificate?: {
    last_downloaded_on?: string | null;
    expires_on?: string | null;
  } | null;
}

export const buildLmsEnrolmentLogEntries = (
  enrolment: LmsEnrolmentForLogs | null | undefined
): LmsEnrolmentLogEntry[] => {
  if (!enrolment) {
    return [];
  }

  const entries: LmsEnrolmentLogEntry[] = [];

  if (enrolment.created_on) {
    entries.push({
      key: "invited_on",
      labelKey: "invited_on",
      value: formatDateValue(enrolment.created_on, true),
    });
  }

  if (enrolment.started_on) {
    entries.push({
      key: "started_on",
      labelKey: "started_on",
      value: formatDateValue(enrolment.started_on, true),
    });
  }

  const completeByDate = enrolment.due_on;
  if (completeByDate) {
    entries.push({
      key: "complete_by",
      labelKey: "how_long_to_complete",
      value: formatDateValue(completeByDate, false),
    });
  }

  if (enrolment.completed_on) {
    entries.push({
      key: "completed_on",
      labelKey: "completed_on",
      value: formatDateValue(enrolment.completed_on, true),
    });
  }

  if (enrolment.certificate?.expires_on) {
    entries.push({
      key: "certificate_expires_on",
      labelKey: "certificate_expires_on",
      value: formatDateValue(enrolment.certificate.expires_on, false),
    });
  }

  if (enrolment.certificate?.last_downloaded_on) {
    entries.push({
      key: "certificate_last_downloaded_on",
      labelKey: "certificate_last_downloaded_on",
      value: formatDateValue(enrolment.certificate.last_downloaded_on, true),
    });
  }

  return entries;
};
